/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export const redactUuids = (
  input: string,
  replacement: string = "<uuid>"
): string => {
  const uuidRegex =
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
  return input.replace(uuidRegex, replacement);
};

export const redactNumericPathSegments = (
  input: string,
  replacement: string = "<number>"
): string => {
  const numericPathSegmentRegex = /\/\d+(?=\/|$)/g;
  return input.replace(numericPathSegmentRegex, `/${replacement}`);
};
